/* eslint-disable */
import * as util from "@/api/agent";
import {
  getAgentSession,
  setXAuthAgent,
  removeXAuthAgent,
  setAgentSession,
  removeAgentSession
} from "@/utils/auth";

const state = {
  agentSession: getAgentSession() != null ? JSON.parse(getAgentSession()) : {},
  x_auth_agent: "",
  fieldsGetAgentList: {
    email: "",
    name: "",
    page: 0,
    perPage: 20
  },
  isShowForm: false,
  formParamSt: {
    id: "",
    email: "",
    first_name: "",
    last_name: ""
  },
  isShowFormP: false,
  formParamStP: {
    id: "",
    email: "",
    new_password: ""
  }
};

const mutations = {
  SET_fieldsGetAgentList: (state, value) => {
    state.fieldsGetAgentList = value;
  },
  SET_agentSession: (state, value) => {
    state.agentSession = value;
  },
  SET_x_auth_agent: (state, value) => {
    state.x_auth_agent = value;
  },
  SET_formParamSt: (state, value) => {
    state.formParamSt = value;
  },
  SET_isShowForm: (state, value) => {
    state.isShowForm = value;
  },
  SET_formParamStP: (state, value) => {
    state.formParamStP = value;
  },
  SET_isShowFormP: (state, value) => {
    state.isShowFormP = value;
  }
};

const actions = {
  setIsShowForm({ commit }, data) {
    commit("SET_isShowForm", data);
  },
  actFormParamSt({ commit }, data) {
    commit("SET_formParamSt", data);
  },
  setIsShowFormP({ commit }, data) {
    commit("SET_isShowFormP", data);
  },
  actFormParamStP({ commit }, data) {
    commit("SET_formParamStP", data);
  },
  updateAgentRolesOneStored({ commit }, dataParams) {
    // console.log(dataParams)
    return new Promise((resolve, reject) => {
      util
        .updateAgentRolesOneStored(dataParams)
        .then(response => {
          // const { data } = response;
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  deleteAgentRolesOneStored({ commit }, dataParams) {
    // console.log(dataParams)
    return new Promise((resolve, reject) => {
      util
        .deleteAgentRolesOneStored(dataParams)
        .then(response => {
          // const { data } = response;
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getAgentRel({ commit }, dataParams) {
    // console.log(dataParams)
    return new Promise((resolve, reject) => {
      util
        .getAgentRel(dataParams)
        .then(response => {
          // const { data } = response;
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  setFieldsGetAgentList({ commit }, data) {
    commit("SET_fieldsGetAgentList", data);
  },
  updatePasswordStored({ commit }, dataParams) {
    // console.log(dataParams)
    return new Promise((resolve, reject) => {
      util
        .updatePasswordStored(dataParams)
        .then(response => {
          // const { data } = response;
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  updateStored({ commit }, dataParams) {
    // console.log(dataParams)
    return new Promise((resolve, reject) => {
      util
        .updateStored(dataParams)
        .then(response => {
          // const { data } = response;
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getAgentById({ commit }, id) {
    // console.log(dataParams)
    return new Promise((resolve, reject) => {
      util
        .getAgentById(id)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getAgentList({ commit }, dataParams) {
    // console.log(dataParams)
    return new Promise((resolve, reject) => {
      util
        .getAgentList(dataParams)
        .then(response => {
          // const { data } = response;
          commit("SET_fieldsGetAgentList", dataParams);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  createStored({ commit }, dataParams) {
    // console.log(dataParams)
    return new Promise((resolve, reject) => {
      util
        .createStored(dataParams)
        .then(response => {
          // const { data } = response;
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  setAgentSession({ commit }, data) {
    commit("SET_agentSession", data);
  },
  setXAuthAgent({ commit }, data) {
    commit("SET_x_auth_agent", data);
  },
  connectToAgentOwner({ commit, dispatch }, dataArr) {
    // console.log(dataParams)
    commit("SET_agentSession", { agentSession: {} });
    commit("SET_x_auth_agent", "");
    removeXAuthAgent("");
    removeAgentSession({ agentSession: {} });
    return new Promise((resolve, reject) => {
      util
        .connectToAgentOwner(dataArr)
        .then(response => {
          const { data } = response;
          commit("SET_agentSession", data);
          commit("SET_x_auth_agent", data.token);
          setXAuthAgent(data.token);
          setAgentSession(data);

          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getTotalScrapeMP({ commit }, dataParams) {
    return new Promise((resolve, reject) => {
      util
        .getTotalScrapeMP(dataParams)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getTotalScrapeStatus({ commit }, dataParams) {
    return new Promise((resolve, reject) => {
      util
        .getTotalScrapeStatus(dataParams)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  totalStatusPerMP({ commit }, dataParams) {
    return new Promise((resolve, reject) => {
      util
        .totalStatusPerMP(dataParams)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  totalKeywords({ commit }, dataParams) {
    return new Promise((resolve, reject) => {
      util
        .totalKeywords(dataParams)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  totalStatusShopee({ commit }, dataParams) {
    return new Promise((resolve, reject) => {
      util
        .totalStatusShopee(dataParams)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  totalStatusTokopedia({ commit }, dataParams) {
    return new Promise((resolve, reject) => {
      util
        .totalStatusTokopedia(dataParams)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  totalStatusLazada({ commit }, dataParams) {
    return new Promise((resolve, reject) => {
      util
        .totalStatusLazada(dataParams)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  totalStatusBukalapak({ commit }, dataParams) {
    return new Promise((resolve, reject) => {
      util
        .totalStatusBukalapak(dataParams)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  reportSummary({ commit }, params) {
    return new Promise((resolve, reject) => {
      util
        .reportSummary(params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/agent.js